/*  MUI  */
import { Box } from '@mui/material';

/*  Components  */
import { Sidebar } from 'application/Shared/Views/Components/Sidebar/Sidebar';

/* Hooks */
import { useSession } from 'hooks/redux/Selectors/session';

/*  React  */
import React from 'react';

export const GlobalView = ({ children, onlyShowChildrenElements, page }) => {
    const session = useSession();
    if (!session) {
        return null;
    }

    if (onlyShowChildrenElements) {
        return children;
    }

    return (
        <Box data-testid="sharedViewsGlobalView" display="flex" width="100%">
            <Sidebar globalView page={page} />
            <Box id="mainViewContainer">{children}</Box>
        </Box>
    );
};
